import $ from "jquery";
import config from "../config";
const URL_API = config.urlApi + "controller/getTreatments.php";

export default function getTreatments(order) {
  return $.ajax({
    url: URL_API,
    type: "POST",
    data: order,
    contentType: false,
    processData: false,
  });
}
